import React, { useState, useEffect } from "react";
import { Grid, makeStyles, ThemeProvider } from "@material-ui/core";
import theme from "../Login/LoginSreen.breakpoints";
import { users } from "../../utils/newApi";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import styles from "./FAQscreen.styles";
import ErrorSnackBar from "../../components/Snackbar/ErrorSnackBar";
import CircularProgress from "@material-ui/core/CircularProgress";
import FAQlist from "../../components/FAQList/FAQlist";
import NewFAQmodalWindow from "../../components/ModalWindows/FAQ/NewFAQmodalWindow";
import ListHeader from "../../components/common/ListHeader";

import {
  SERVER_ERROR_MESSAGES,
  ERROR_MESSAGES,
} from "../../constants/dictionary";

const useStyles = makeStyles(styles);

const FAQscreen = () => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const matches = useMediaQuery(theme.breakpoints.down("sm"));
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(false);
  const [faqs, setFaqs] = useState([]);
  const [errorText, setErrorText] = useState("");

  const handleError = (text) => {
    setError(true);
    setErrorText(text);
  };

  useEffect(() => {
    users.faq
      .all()
      .then((res) => {
        const sorted = res.data ? res.data.sort((a, b) => b.id - a.id) : [];
        setFaqs(sorted);
      })
      .catch((err) => {
        handleError(SERVER_ERROR_MESSAGES.COULD_NOT_DOWNLOAD_FAQ);
      });
    setIsLoaded(true);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      {isLoaded ? (
        <Grid container spacing={matches ? 3 : 0}>
          <ListHeader
            variant="title-add"
            title="Lista FAQ"
            handleAdd={() => setOpen(true)}
          />
          <Grid container>
            <Grid item xs={12} align="center">
              <FAQlist
                listOfFaqs={faqs}
                setFaqs={setFaqs}
                handleError={handleError}
              />
            </Grid>
          </Grid>
          <NewFAQmodalWindow
            isOpen={open}
            close={() => setOpen(false)}
            handleError={handleError}
          />
        </Grid>
      ) : (
        <div className={classes.container}>
          <CircularProgress color="secondary" className={classes.loader} />
        </div>
      )}
      <ErrorSnackBar
        open={error}
        text={ERROR_MESSAGES.COULD_NOT_CONNECT_TO_SERVER}
        close={() => setError(false)}
      />
    </ThemeProvider>
  );
};

export default FAQscreen;
